import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CompleteGuidePage from "@/pages/articles/CompleteGuidePage";
import KakobuyComparisonPage from "@/pages/articles/KakobuyComparisonPage";
import CSSBuyComparisonPage from "@/pages/articles/CSSBuyComparisonPage";
import SuperbuyComparisonPage from "@/pages/articles/SuperbuyComparisonPage";
import OopbuyComparisonPage from "@/pages/articles/OopbuyComparisonPage";
import SafetyGuidePage from "@/pages/articles/SafetyGuidePage";
import BeginnerTutorialPage from "@/pages/articles/BeginnerTutorialPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <CompleteGuidePage />,
  },
  {
    path: "/hipobuy-spreadsheet-complete-guide",
    element: <CompleteGuidePage />,
  },
  {
    path: "/hipobuy-spreadsheet-safety",
    element: <SafetyGuidePage />,
  },
  {
    path: "/hipobuy-spreadsheet-beginner",
    element: <BeginnerTutorialPage />,
  },
  {
    path: "/hipobuy-vs-kakobuy",
    element: <KakobuyComparisonPage />,
  },
  {
    path: "/hipobuy-vs-cssbuy",
    element: <CSSBuyComparisonPage />,
  },
  {
    path: "/hipobuy-vs-superbuy",
    element: <SuperbuyComparisonPage />,
  },
  {
    path: "/hipobuy-vs-oopbuy",
    element: <OopbuyComparisonPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;